import { __t } from '@/lib/helpers'
import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import { PROMOTION_ROUTE_KEYS } from '@/components/promotion/consts'

export default {
  path: 'boost',
  name: 'boost',
  meta: {
    title: __t('routes.promotion.boost.title'),
    subtitle: __t('routes.promotion.boost.subtitle'),
    icon: {
      inactive: 'promotion/boost-inactive.svg',
      active: 'promotion/boost-active.svg',
      color: '#7730D7',
    },
    key: PROMOTION_ROUTE_KEYS.BOOST,
    restrictedAccessLevels: [ACCESS_LEVELS.STAFF, ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION],
  },
  component: () => import('@/views/business/promotion/boost/index.vue'),
  children: [
    {
      path: 'details',
      name: 'boost.details',
      meta: {
        title: __t('routes.promotion.boost-details.title'),
      },
      component: () => import('@/views/business/promotion/boost/boost-details/index.vue'),
    },
    {
      path: 'help',
      name: 'boost.help',
      meta: {
        title: __t('routes.promotion.boost-help.title'),
        subtitle: __t('routes.promotion.boost-help.subtitle'),
      },
      component: () => import('@/views/business/promotion/boost/boost-help/index.vue'),
      children: [
        {
          path: 'how-it-work',
          name: 'boost.help.how-it-work',
          meta: {
            title: __t('routes.promotion.boost-help.how-it-work.title'),
          },
          component: () => import('@/views/business/promotion/boost/boost-help/how-it-work.vue'),
        },
        {
          path: 'claim-clients',
          name: 'boost.help.claim-clients',
          meta: {
            title: __t('routes.promotion.boost-help.claim-clients.title'),
          },
          component: () => import('@/views/business/promotion/boost/boost-help/claim-clients.vue'),
        },
        {
          path: 'prevent-accidental-charges',
          name: 'boost.help.prevent-accidental-charges',
          meta: {
            title: __t('routes.promotion.boost-help.prevent-accidental-charges.title'),
          },
          component: () => import('@/views/business/promotion/boost/boost-help/prevent-accidental-charges.vue'),
        },
        {
          path: 'identifying-new-clients',
          name: 'boost.help.identifying-new-clients',
          meta: {
            title: __t('routes.promotion.boost-help.identifying-new-clients.title'),
          },
          component: () => import('@/views/business/promotion/boost/boost-help/identifying-new-clients.vue'),
        },
        {
          path: 'pricing',
          name: 'boost.help.pricing',
          meta: {
            title: __t('routes.promotion.boost-help.pricing.title'),
          },
          component: () => import('@/views/business/promotion/boost/boost-help/pricing.vue'),
        },
        {
          path: 'terms-and-conditions',
          name: 'boost.help.terms-and-conditions',
          meta: {
            title: __t('routes.promotion.boost-help.terms-and-conditions.title'),
            shouldBeVisible: (boostConditions) => {
              return !!boostConditions?.terms
            },
          },
          component: () => import('@/views/business/promotion/boost/boost-help/terms-and-conditions.vue'),
        },
      ],
    },
  ],
}
